import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const AlignBottomIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-align-bottom', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path d='M9.71429 12.4H11.4286C11.9026 12.4 12.2857 12.0126 12.2857 11.5333V2.86667C12.2857 2.3874 11.9026 2 11.4286 2H9.71429C9.24029 2 8.85714 2.3874 8.85714 2.86667V11.5333C8.85714 12.0126 9.24029 12.4 9.71429 12.4Z' />
      <path d='M2.85714 15H13.1429C13.6169 15 14 14.6126 14 14.1333C14 13.6541 13.6169 13.2667 13.1429 13.2667H2.85714C2.38314 13.2667 2 13.6541 2 14.1333C2 14.6126 2.38314 15 2.85714 15Z' />
      <path d='M4.57143 12.4H6.28571C6.75971 12.4 7.14286 12.0126 7.14286 11.5333V8.06667C7.14286 7.5874 6.75971 7.2 6.28571 7.2H4.57143C4.09743 7.2 3.71429 7.5874 3.71429 8.06667V11.5333C3.71429 12.0126 4.09743 12.4 4.57143 12.4Z' />
    </svg>
  );
};

export default AlignBottomIcon;
